import { PostExcelsCompressDownloadsRequest } from 'ncp-api-supporter';
import {saveAs} from 'file-saver';
import { api } from '@/api';

export interface CertificationData {
  reason: string;
  password: string;
}

export type CertificationDataKey = keyof CertificationData;

const fetchExcelDownload = async (excelNo: number, reason?: string, password?: string): Promise<Blob> => {
  const request: PostExcelsCompressDownloadsRequest = {
    data: {
      excelNo,
      reason,
      password
    },
  };

  try {
    const response = await api.postExcelsCompressDownload(request);
    return new Blob([response.data], { type: 'application/zip' });
  } catch (error) {
    const errorText = await (new Response(error.data).text());
    const { code, message } = JSON.parse(errorText)
    switch (code) {
      case 'EB0005':
        alert(window.$t('EXCEL_DOWNLOAD_ALERT_NO_DOWNLOAD_PERMISSION'));
        break;
      default:
        alert(message);
        break;
    }

    throw new Error(code)
  }
};

export const handleExcelDownloadProcess = async (excelNo: number, fileName: string, certificationData?: CertificationData): Promise<void> => {
  const blob = await fetchExcelDownload(excelNo, certificationData?.reason, certificationData?.password);

  const fileNameWithExtension = `${fileName}.zip`;
  saveAs(blob, fileNameWithExtension.normalize('NFC'));
};
